(function () {
  var SELECTOR = "[data-modular-cards-flip-card]";
  var SLIDER_SELECTOR = ".modular-cards-flip__cards.slider";
  var FLIPPED_CLASS = "is-flipped";
  var MQ = "(min-width: 992px)";

  function canFlip() {
    return (
      typeof window.matchMedia === "function" &&
      window.matchMedia(MQ).matches
    );
  }

  function isInfiniteSlider(slider) {
    return slider && slider.getAttribute("data-mcf-infinite") === "true";
  }

  function setFlipped(card, flipped) {
    card.classList.toggle(FLIPPED_CLASS, flipped);
    if (canFlip()) {
      card.setAttribute("aria-pressed", flipped ? "true" : "false");
    }
  }

  function setInteractive(card, enabled) {
    if (enabled) {
      card.setAttribute("tabindex", "0");
      card.setAttribute(
        "aria-pressed",
        card.classList.contains(FLIPPED_CLASS) ? "true" : "false"
      );
    } else {
      setFlipped(card, false);
      card.setAttribute("tabindex", "-1");
      card.removeAttribute("aria-pressed");
    }
  }

  function syncFlippedState(slider, cardId, flipped) {
    slider
      .querySelectorAll(SELECTOR + '[data-mcf-card-id="' + cardId + '"]')
      .forEach(function (card) {
        setFlipped(card, flipped);
      });
  }

  function toggleFlip(card) {
    if (!canFlip()) return;
    setFlipped(card, !card.classList.contains(FLIPPED_CLASS));
  }

  function onClick(event) {
    toggleFlip(event.currentTarget);
  }

  function onInfiniteClick(event) {
    var slider = event.currentTarget;
    var card = event.target.closest(SELECTOR);

    if (!card || !slider.contains(card) || !canFlip()) return;

    var cardId = card.getAttribute("data-mcf-card-id");
    var flipped = !card.classList.contains(FLIPPED_CLASS);

    if (cardId) {
      syncFlippedState(slider, cardId, flipped);
      return;
    }

    setFlipped(card, flipped);
  }

  function syncViewport(container) {
    var enabled = canFlip();
    var scope = container || document;
    scope.querySelectorAll(SELECTOR).forEach(function (card) {
      setInteractive(card, enabled);
    });
  }

  function init(card) {
    if (!card || card.getAttribute("data-mcf-initialized") === "true") return;

    card.setAttribute("data-mcf-initialized", "true");
    card.addEventListener("click", onClick);
    setInteractive(card, canFlip());
  }

  function bindInfiniteSlider(slider) {
    if (slider.getAttribute("data-mcf-infinite-bound") === "true") return;

    slider.setAttribute("data-mcf-infinite-bound", "true");
    slider.addEventListener("click", onInfiniteClick);

    var $ = window.jQuery || window.$;
    if ($) {
      $(slider).on("reInit.mcf", function () {
        syncViewport(slider);
      });
    }
  }

  function whenSlickReady(slider, callback) {
    if (slider.classList.contains("slick-initialized")) {
      callback();
      return;
    }

    var $ = window.jQuery || window.$;
    if ($) {
      $(slider).on("init.mcf", function () {
        callback();
      });
      return;
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;
      if (!slider.isConnected) {
        window.clearInterval(interval);
        return;
      }
      if (slider.classList.contains("slick-initialized") || attempts > 80) {
        window.clearInterval(interval);
        if (slider.classList.contains("slick-initialized")) callback();
      }
    }, 25);
  }

  function initInfiniteSlider(slider) {
    if (slider.getAttribute("data-mcf-infinite-pending") === "true") return;

    slider.setAttribute("data-mcf-infinite-pending", "true");
    whenSlickReady(slider, function () {
      bindInfiniteSlider(slider);
      syncViewport(slider);
    });
  }

  function scan(container) {
    var scope = container || document;

    scope.querySelectorAll(SLIDER_SELECTOR).forEach(function (slider) {
      if (isInfiniteSlider(slider)) initInfiniteSlider(slider);
    });

    scope.querySelectorAll(SELECTOR).forEach(function (card) {
      var slider = card.closest(SLIDER_SELECTOR);
      if (slider && isInfiniteSlider(slider)) return;
      init(card);
    });

    syncViewport(scope);
  }

  function bindMedia() {
    if (typeof window.matchMedia !== "function") return;

    var mql = window.matchMedia(MQ);
    var onChange = function () {
      syncViewport();
    };

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", onChange);
    } else if (typeof mql.addListener === "function") {
      mql.addListener(onChange);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scan();
      bindMedia();
    });
  } else {
    scan();
    bindMedia();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event && event.target) scan(event.target);
  });
})();
